require('./rejectChoreStep.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @actions
const openYoungCardRejectChoreActions = require('actions/openYoungCardRejectChore');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');

// @constants
const { EURO_TEXT } = require('constants/index');

class RejectChoreStep2 extends React.Component {
    constructor(props){
        super(props);
        this.createList = this.createList.bind(this);
        this.handleSetRemark = this.handleSetRemark.bind(this);
    }

    createList(list) {
        return list.map((item, key) => {
            if(item.bodyText){
                return (
                    <OKInformativeListItem
                        className={"reject-chores-step__list-item"}
                        key={key}
                        title={item.title}
                        bodyText={item.bodyText}
                        bodyWordBreak={false}
                    />
                )
            }
        })
    }

    handleSetRemark(event){
        const remark = event.target.value;
        this.props.setRemark(remark);
    }

    render() {
        const { immStep, choreDetail, childName} = this.props;
        const currency = formatCurrency(EURO_TEXT);
        const reward = getFormattedString({ amount: choreDetail.get('reward'), currency });
        const formattedChildName = childName && childName.split(" ").map(str => toFirstUppercase(str)).join(" ");
        const list = [
            {
                title: formatText('openYoungRejectChores-applicant'),
                bodyText: formattedChildName
            },
            {
                title: formatText('openYoungRejectChores-chore'),
                bodyText: formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`)
            },
            {
                title: formatText('openYoungRejectChores-amount'),
                bodyText: reward
            },
            {
                title: formatText('openYoungRejectChores-concept'),
                bodyText: choreDetail.getIn(['comments','choreAssignmentComment'])
            },
            {
                title: formatText('openYoungRejectChores-answer'),
                bodyText: choreDetail.getIn(['comments','childComment'])
            },
            {
                title: formatText('openYoungRejectChores-reason'),
                bodyText: immStep.get('remark')
            }
        ];

        return (
            <article className="reject-chores-step">
                <section>
                    <h2 className="reject-chores-step__heading">
                        <FormattedText value="openYoungRejectChores-step2Heading" />
                    </h2>
                    <h5 className="reject-chores-step__sub-heading">
                        <FormattedText value="openYoungRejectChores-step2SubHeading" />
                    </h5>
                </section>
                <section className="reject-chores-step__main">
                    <OKInformativeList columns={2}>
                        {this.createList(list)}
                    </OKInformativeList>
                </section>
            </article>
        );
    }
}

RejectChoreStep2.propTypes = {
    childName: PropTypes.string,
    choreDetail: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    setRemark: PropTypes.func,
};

module.exports.RejectChoreStep2 = connect(
    null,
    {
        setRemark: openYoungCardRejectChoreActions.setRemark
    })(RejectChoreStep2);
